import { jsx as _jsx } from "react/jsx-runtime";
import { SpinnerIcon } from '@bnb-chain/icons';
import { forwardRef, keyframes } from '@chakra-ui/react';
const SPINNER = keyframes `
  from {
      transform: rotate(0deg);
  }
  to { 
      transform: rotate(360deg);
  }
`;
export const Spinner = forwardRef((props, ref) => {
    return (_jsx(SpinnerIcon, { ref: ref, sx: {
            animationName: `${SPINNER}`,
            animationDuration: '1s',
            animationTimingFunction: 'linear',
            animationIterationCount: 'infinite',
        }, ...props }));
});
